import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';

import { IAlyceCustomTheme } from '../../../../styles/alyceTheme';

export const useStyles = makeStyles<IAlyceCustomTheme, { isMobile: boolean; isSentProduct: boolean }>(
  ({ palette, spacing }) => ({
    buttonBlock: ({ isMobile, isSentProduct }) => ({
      visibility: isSentProduct ? 'visible' : 'hidden',
      opacity: 0,
      borderRadius: isMobile ? 5 : '0 0 5px 5px',
      backgroundColor: alpha(palette.customStyling.backgroundColor, 0.8),
      minHeight: isMobile ? 146 : 88,
    }),
    alwaysVisibleButtonBlock: ({ isMobile }) => ({
      visibility: 'visible',
      opacity: 1,
      minHeight: isMobile ? 146 : 88,
      borderRadius: isMobile ? 5 : '0 0 5px 5px',
    }),
    buttonIcon: {
      width: 16,
      height: 16,
      marginRight: spacing(1),
    },
    buttonText: {
      lineHeight: 1,
    },
    media: ({ isMobile }) => ({
      width: isMobile ? 155 : 276,
      height: isMobile ? 146 : 220,
      backgroundSize: 'auto 100%',
    }),
    itemText: ({ isMobile }) => ({
      width: isMobile ? 137 : 250,
    }),
    productName: {
      '&:hover': {
        color: palette.customStyling.highlightColor,
      },
    },
    avatar: ({ isMobile }) => ({
      width: isMobile ? 40 : 56,
      height: isMobile ? 40 : 56,
      marginTop: isMobile ? 0 : spacing(1),
      marginRight: spacing(isMobile ? 0 : 2),
      border: `2px solid ${palette.common.white}`,
    }),
  }),
);
